import { CompoundFilterItemProps } from './CompoundFilterItem.types';
import { Button } from '../../../../../buttons/Button';
import { RenderWhen } from '../../../../../RenderWhen';
import { OptionCount } from './components';
import { getActiveCount } from './helpers';
import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';

export const CompoundFilterItem = ({
  isActive,
  onClick,
  label,
  options,
  className,
}: CompoundFilterItemProps) => {
  const count = getActiveCount(options);

  return (
    <Button
      // this is a temporary fix to make the button width not overflowing the container
      size="md"
      className={flattenClassNames(['!h-8 !w-28 p-0', className])}
      onClick={onClick}
      isActive={isActive}
      color={isActive ? 'primary' : 'secondary'}
    >
      {label}
      <RenderWhen condition={count > 0}>
        <OptionCount isActive={isActive} count={count} />
      </RenderWhen>
    </Button>
  );
};
